import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainTitle from '@components/MainTitle';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import TerraMain from '@views/Devices/TerraMain';

const messages = defineMessages({
  devices: {
    id: 'devicesMain.devices',
    defaultMessage: 'My Health Devices',
  },
});

export default function DevicesPage({ params }: PageProps) {
  const { formatMessage } = useIntl();

  return (
    <AppLayout showHeader>
      <MainContainer>
        <MainTitle title={formatMessage(messages.devices)} />
        <TerraMain {...params} />
      </MainContainer>
    </AppLayout>
  );
}
